export { Provision } from "@pdfking/pdfium/compatibility"
